import router from './router'
// import store from './store'
import settings from './settings'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import Cookies from './utils/cookies'
import User from './api/user'
import Currency from './api/currency'
import UserAuth from './api/userAuth'

import ls from 'store2'

NProgress.configure({ showSpinner: false })

const whiteList = ['/', '/register', '/normal/adapter/shopifys/show']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  document.title = settings.title

  const jyToken = Cookies.getToken()
  const user = ls.session('USER')

  // 白名单直接跳转
  if (whiteList.indexOf(to.path) !== -1) {
    next();
    NProgress.done()
    console.log("==permisission")
    return;
  }
  // 没有unionid跳转到登录页
  if (!jyToken) {
    next(`/`)
    NProgress.done()
    return;
  }
  // console.log("===permission:user", user)
  // 有user信息,并且访问主页面，直接跳转到主页
  if (user != null && user.id != null && to.path === '/') {
    next({ path: '/normal/dashboard' })
    NProgress.done()
    return;
  }

  // 有user信息,并且访问登录页，直接跳转到主页
  if (user != null && user.id != null) {
    next()
    NProgress.done()
    return;
  }

  // 没有user信息，获取user 信息
  const userRes = await User.findByUnionid({ unionid: jyToken })
  // console.log("===permission:userRes", userRes)

  // 后台无响应
  if (userRes.data.code != 200) {
    next(`/`)
    Cookies.removeToken()
    ls.clearAll();
    Message.error('登录已失效，请重新登录！')
    return;
  }

  // 用户登录授权已失效
  if (jyToken != userRes.data.entity.webToken) {
    next(`/`)
    Cookies.removeToken()
    ls.clearAll();
    Message.error('登录已失效，请重新登录')
    return;
  }

  // 保存user信息
  getCurrencies()
  const userData = userRes.data.entity
  const tenant = userData.tenant
  ls.session('USER', userData)
  ls.session('TENANT', tenant)
  if (JSON.parse(tenant.charge.extendModelNew).includes('mms')) {
    await getUserAuthsMms(userData.id)
  }
  if (JSON.parse(tenant.charge.extendModelNew).includes('mes')) {
    await getUserAuthsMes(userData.id)
  }
  next(to.path)
})

router.afterEach(() => {
  NProgress.done()
})

function getCurrencies() {
  Currency.findByTenantId().then(currencyRes => {
    if (currencyRes.status === 200) {
      ls.session('CURRENCIES', currencyRes.data)
      // store.dispatch('setCurrencies', currencyRes.data)
    } else {
      // self.sysError()
    }
  })
}

// 物料权限
async function getUserAuthsMms(userId) {
  const userAuthsMmsRes = await UserAuth.findByIdMms(userId)
  if (userAuthsMmsRes.data.code === 200) {
    const userAuthsMms = userAuthsMmsRes.data.entity
    ls.session('MMSAUTHSUNJECTIDS', JSON.parse(userAuthsMms.subjectsJson || "[]"))
    // store.dispatch('setMmsAuthSubjuctIds', JSON.parse(userAuthsMms.subjectsJson))
    ls.session('MMSUSERAUTHS', JSON.parse(userAuthsMms.actionsJson || "[]"))
    // store.dispatch('setMmsUserAuths', JSON.parse(userAuthsMms.actionsJson))
  } else {
    // 其他是没有授权的
  }
}

// 工厂权限
async function getUserAuthsMes(userId) {
  const userAuthsMesRes = await UserAuth.findByIdMes(userId)
  if (userAuthsMesRes.data.code === 200) {
    const userAuthsMes = userAuthsMesRes.data.entity;
    ls.session(
      "MESAUTHPHASEIDS",
      JSON.parse(userAuthsMes.phasesJson || "[]")
    );
    // store.dispatch('setMesAuthPhaseIds', JSON.parse(userAuthsMes.phasesJson || "[]"))
    ls.session(
      "MESUSERAUTHS",
      JSON.parse(userAuthsMes.actionsJson || "[]")
    );
    // store.dispatch('setMesUserAuths', JSON.parse(userAuthsMes.actionsJson))
  } else {
    // 其他是没有授权的
  }
}
